import React from 'react'
import s from './PanelBase.module.scss'
import ReadOnlyOperatorsList from './ReadOnlyOperatorsList'
import ReadOnlyDriversList from './ReadOnlyDriversList'
import ReadOnlyBranchesList from './ReadOnlyBranchesList'
import MiniMap from 'pages/ReportCard/MiniMap'

const PrivatePointsPanel = ({
  privatePointsFilter,
  setPrivatePointsFilter,
  filteredPrivatePoints,
  privatePointsPagination,
  loadPrivatePointsPage,
  expandedPrivatePoint,
  setExpandedPrivatePoint,
  expandedOperatorsPrivatePoint,
  setExpandedOperatorsPrivatePoint,
  expandedDriversPrivatePoint,
  setExpandedDriversPrivatePoint,
  expandedBranchesPrivatePoint,
  setExpandedBranchesPrivatePoint,
  loadOperatorsByPrivatePointPage,
  loadDriversByPrivatePointPage,
  loadBranchesByPrivatePointPage,
  operatorsByPrivatePoint,
  driversByPrivatePoint,
  branchesByPrivatePoint,
  operatorsPaginationByPrivatePoint,
  driversPaginationByPrivatePoint,
  branchesPaginationByPrivatePoint,
  operatorsFilterByPrivatePoint,
  driversFilterByPrivatePoint,
  branchesFilterByPrivatePoint,
  setOperatorsFilterByPrivatePoint,
  setDriversFilterByPrivatePoint,
  setBranchesFilterByPrivatePoint,

  expandedDriverByPrivatePoint,
  toggleDriver,
  privatePoints
}) => {
  return (
    <div className={s.panel}>
      <div className={s.header}>
        <h2 className={s.title}>Соц. Объекты и МСУ</h2>
        {privatePointsPagination?.count > 0 && (
          <span className={s.totalBadge}>Всего: {privatePointsPagination.count}</span>
        )}
      </div>

      <div className={s.searchRow}>
        <input className={s.searchInput} placeholder="Поиск по объекту..." value={privatePointsFilter} onChange={(e) => setPrivatePointsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadPrivatePointsPage(1, privatePointsFilter) }} />
      </div>

      {filteredPrivatePoints && filteredPrivatePoints.length ? (
        <div className={s.tableWrap}>
          <div className={s.tableScroll}>
          <table className={s.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>Название</th>
                <th>Телефон</th>
                <th>Местоположение</th>
                <th>Действия</th>
              </tr>
            </thead>
            <tbody>
              {filteredPrivatePoints.map((pp, index) => (
                <React.Fragment key={pp.id}>
                  <tr>
                    <td className={s.numCell}>{index + 1}</td>
                    <td className={s.nameCell} onClick={() => { const newVal = (expandedPrivatePoint === pp.id ? null : pp.id); setExpandedPrivatePoint(newVal); if (newVal) loadOperatorsByPrivatePointPage(pp.id, 1); }}>{pp.name}</td>
                    <td>{pp.phone || '—'}</td>
                    <td>
                      {pp.geo ? (
                        <div style={{ display: 'flex', gap: '6px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', gap: '6px' }}>
                            <button onClick={() => window.open(`https://www.google.com/maps?q=${pp.geo}`, '_blank')} className={s.geoBtn}>🗺️ Карты</button>
                            <button onClick={() => { const el = document.getElementById(`pp-map-${pp.id}`); if (el) el.style.display = el.style.display === 'none' ? 'block' : 'none'; }} className={s.mapToggleBtn}>📌</button>
                          </div>
                          <div id={`pp-map-${pp.id}`} style={{ width: 200, height: 150, display: 'none' }}><MiniMap geo={pp.geo} /></div>
                        </div>
                      ) : '—'}
                    </td>
                    <td>
                      <button className={`${s.actionBtn}${expandedBranchesPrivatePoint === pp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedBranchesPrivatePoint === pp.id ? null : pp.id; setExpandedBranchesPrivatePoint(v); if (v) loadBranchesByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}>Филиалы</button>
                      <button className={`${s.actionBtn}${expandedOperatorsPrivatePoint === pp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedOperatorsPrivatePoint === pp.id ? null : pp.id; setExpandedOperatorsPrivatePoint(v); if (v) loadOperatorsByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}>Операторы</button>
                      <button className={`${s.actionBtn}${expandedDriversPrivatePoint === pp.id ? ' ' + s.active : ''}`} onClick={() => { const v = expandedDriversPrivatePoint === pp.id ? null : pp.id; setExpandedDriversPrivatePoint(v); if (v) loadDriversByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}>Водители</button>
                    </td>
                  </tr>
                  {expandedPrivatePoint === pp.id && (
                    <tr className={s.subRow}>
                      <td colSpan={5}>
                        <div className={s.subContent}>
                          {expandedOperatorsPrivatePoint === pp.id && (
                            <ReadOnlyOperatorsList
                              base={pp}
                              operators={operatorsByPrivatePoint[pp.id]}
                              operatorsFilter={operatorsFilterByPrivatePoint[pp.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadOperatorsPage={loadOperatorsByPrivatePointPage}
                              operatorsPagination={operatorsPaginationByPrivatePoint[pp.id]}
                              title="Операторы этого соц.объекта или МСУ"
                            />
                          )}

                          {expandedDriversPrivatePoint === pp.id && (
                            <ReadOnlyDriversList
                              base={pp}
                              drivers={driversByPrivatePoint[pp.id]}
                              driversFilter={driversFilterByPrivatePoint[pp.id]}
                              setDriversFilter={(v) => setDriversFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadDriversPage={loadDriversByPrivatePointPage}
                              driversPagination={driversPaginationByPrivatePoint[pp.id]}
                              expandedDriver={expandedDriverByPrivatePoint}
                              toggleDriver={toggleDriver}
                              title="Водители этого соц.объекта или МСУ"
                            />
                          )}

                          {expandedBranchesPrivatePoint === pp.id && (
                            <ReadOnlyBranchesList
                              base={pp}
                              baseType="соц.объекта или МСУ"
                              branches={branchesByPrivatePoint[pp.id]}
                              branchesFilter={branchesFilterByPrivatePoint[pp.id]}
                              setBranchesFilter={(v) => setBranchesFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadBranchesPage={loadBranchesByPrivatePointPage}
                              branchesPagination={branchesPaginationByPrivatePoint[pp.id]}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      ) : (
        <div className={s.empty}>Список пуст</div>
      )}

      {!privatePointsFilter && privatePointsPagination?.count > 0 && (
        <div className={s.pagination}>
          <button className={s.pageBtn} disabled={!privatePointsPagination.previous} onClick={() => loadPrivatePointsPage((privatePointsPagination.page || 1) - 1)}>Пред.</button>
          <span>Стр. {privatePointsPagination.page || 1} из {Math.ceil(privatePointsPagination.count / 25)}</span>
          <button className={s.pageBtn} disabled={!privatePointsPagination.next} onClick={() => loadPrivatePointsPage((privatePointsPagination.page || 1) + 1)}>След.</button>
        </div>
      )}
    </div>
  )
}

export default PrivatePointsPanel
